// extracted by mini-css-extract-plugin
module.exports = {"calc_desc":"style_calc_desc__27CER","calc_desc__title":"style_calc_desc__title__w2WA-","calc_desc__text":"style_calc_desc__text__2tj_Y"};